import React from 'react';
import ktcLogo from '../assets/ktc.png';

export default function StaffPageLoadingOverlay({ text = 'Memuat data...' }) {
  return (
    <div className="fixed inset-0 z-[5000] flex items-center justify-center bg-[#040913]/82 backdrop-blur-sm">
      <div className="rounded-xl border border-cyan-300/35 bg-[#091120]/90 px-6 py-5 text-center shadow-[0_0_28px_rgba(0,229,255,0.18)]">
        <img src={ktcLogo} alt="KTC" className="mx-auto mb-3 h-14 w-auto animate-pulse" />
        <div className="mx-auto mb-3 h-7 w-7 rounded-full border-2 border-cyan-300/35 border-t-cyan-300 animate-spin" />
        <p className="text-sm font-medium text-cyan-100/90">{text}</p>
      </div>
    </div>
  );
}

